export const SET_PERSONA_ACCESS_DATA = "SET_PERSONA_ACCESS_DATA";

export const setAllPersonaAccessData = (payload) => ({
  type: SET_PERSONA_ACCESS_DATA,
  payload,
});
